export enum SalesInfoPageOption {
  'BOS_MODIFY' = '수정전표',
  'NO_GAUGE' = '게이지 외',
  'PAY_TYPE' = '매출 거래처 기준조회',
}
